import { useState } from 'react';
import styled from 'styled-components';
import RedScreenLayout from '../components/RedScreenLayout';
import TermsModal from '../components/TermsModal';
import DownloadApp from '../components/DownloadApp';
import { offerFootnote } from '../offer';

const Heading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 32px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;
  margin: 32px 16px 16px;
`;

const SubText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 0 0 16px;
`;

const TcLink = styled.a`
  display: block;
  font-family: 'Speedee Regular';
  font-size: 12px;
  color: #ffffff;
  opacity: 0.7;
  text-align: center;
  margin: 0 16px 24px;
  text-decoration: underline;
  cursor: pointer;
  max-width: 328px;
`;

function ClaimFailed({ offer }) {
  const [showTerms, setShowTerms] = useState(false);

  const handleTcsClick = () => {
    setShowTerms(true);
    window.gtag('event', 'mm-allclaimed-btn-tcs');
  };

  return (
    <RedScreenLayout>
      <Heading>All Big Macs® have been claimed!</Heading>

      <SubText>Don't miss the next one.</SubText>

      <TcLink as="p" style={{ textDecoration: 'none', cursor: 'default' }}>
        {offerFootnote(offer)}&nbsp;
        <a onClick={handleTcsClick} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#FFFFFF' }}>
          Terms & Conditions apply.
        </a>
      </TcLink>

      <DownloadApp page="allclaimed" />

      {showTerms && <TermsModal offer={offer} onClose={() => setShowTerms(false)} />}
    </RedScreenLayout>
  );
}

export default ClaimFailed;
